import { IntlShape } from 'react-intl';

/**
 * Release dates are stored as an instant and are usually the artist's day at
 * UTC midnight. Every format here reads them in UTC: rendering the same value
 * in the reader's timezone moves a midnight release onto the day before.
 */
const UTC = 'UTC';

/** True when the artist picked an hour, not just a day. */
export function hasTimeOfDay(isoDate: string): boolean {
  const parsed = new Date(isoDate);
  return parsed.getUTCHours() !== 0 || parsed.getUTCMinutes() !== 0;
}

/** "Sat 29 Aug", plus the hour when the stored date carries one. */
export function formatReleaseDay(intl: IntlShape, isoDate: string): string {
  return intl.formatDate(isoDate, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    timeZone: UTC,
    ...(hasTimeOfDay(isoDate) ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
}

/** "29 Aug" — the timeline's markers and the header's opened date. */
export function formatShortDay(intl: IntlShape, isoDate: string | number): string {
  return intl.formatDate(isoDate, { day: 'numeric', month: 'short', timeZone: UTC });
}

/** Whole days between two instants, never negative. */
export function daysBetween(from: string | number, to: number): number {
  const start = new Date(from).getTime();
  if (Number.isNaN(start)) {
    return 0;
  }
  return Math.max(0, Math.floor((to - start) / 86400000));
}
